import {registerJQueryComponent} from '@lib/JQueryRegistry'

export default class LoginForm {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            submitButton: rootElement.find('.js-login-submit-btn'),
            form: rootElement.find('form'),
            inputs: rootElement.find('.login-form-field').toJQueryObjectsArray(),
            loader: $('.login-form-loader'),
            window: $(window)
        }

        this.$dom.submitButton.click(this.playAnimation)

        // Submit form on ENTER, but only if we're focused on an input. 
        this.$dom.inputs.forEach(input => {
            let actualInput = input.find('input')
            actualInput.on('focus', () => this.$dom.window.on('keyup', this.onWindowKeyUp))
            actualInput.on('blur', () => this.$dom.window.off('keyup', this.onWindowKeyUp))
        })
    }

    onWindowKeyUp = e => {
        if (e.which === 13) {
            this.playAnimation()
        }
    }

    playAnimation = () => {
        if (this.canSubmitForm() === false) {
            return
        }

        this.$dom.loader.css({
            display: 'flex',
            opacity: 0,
            borderSpacing: 3.75
        })

        this.$dom.loader.animate({
            opacity: 1,
            borderSpacing: 2.25
        }, {
            duration: 200,
            easing: 'easeOutQuad',
            step: (fx) => {
                this.$dom.loader.css('transform', 'scale(' + (fx / 2) + ')')
            },
            complete: () => {
                this.$dom.form.submit()
            },
        })
    }

    /**
     * Returns whether all inputs are filled.
     * @return {bool}
     */
    canSubmitForm() {
        let valid = true
        this.$dom.inputs.forEach(input => {
            let component = input.getComponent()
            if (component) {
                component.validate();
                valid = valid && component.isValid();
            }
        })

        return valid
    }
}

registerJQueryComponent(LoginForm, '.page-login .login-wrapper')
registerJQueryComponent(LoginForm, '.page-register .login-wrapper')
registerJQueryComponent(LoginForm, '.page-remind-password .login-wrapper')
